import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FAQBadgeContainer } from '@app/common/src/components/FAQs/FAQBadgeContainer'
import { PrismicAccordion } from '@app/prismic/src/components/PrismicAccordion/PrismicAccordion'
import { PrismicAccordionSlice } from '@dtx-company/true-common/src/types/PrismicAccordionSlice'
import { PrismicRichText } from '@prismicio/react'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { asText } from '@prismicio/client'
import events from '@dtx-company/inter-app/src/event-tracking/events/miscellaneous'

export const Accordion = ({ primary, items }: PrismicAccordionSlice): JSX.Element => {
  return (
    <Box flexDirection="column" justifyContent="center" gridColumn={'1 / -1'}>
      <Text variant="display/large" textAlign="center">
        {asText(primary.heading)}
      </Text>
      <Spacer mt="24px" />
      <Box justifyContent="center" px="16px" maxWidth="900px" m="0 auto">
        <PrismicAccordion
          items={items}
          onToggledAccordion={events.Core_UseCasePage_Toggled_AccordionItem}
          shouldItemsStartExpanded={true}
        />
      </Box>
      {asText(primary.footer) && (
        <Box justifyContent="center" mt="16px">
          <FAQBadgeContainer>
            <PrismicRichText field={primary.footer} />
          </FAQBadgeContainer>
        </Box>
      )}
      <Spacer mt="24px" />
    </Box>
  )
}
